"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FormFieldErrorMessage = function FormFieldErrorMessage(props) {
  return _react.default.createElement(StyledBox, props);
};

var StyledBox = (0, _styledComponents.default)(_box.default)(_templateObject());
FormFieldErrorMessage.defaultProps = {
  paddingTop: 0,
  mr: '5px',
  height: '23px',
  maxWidth: '85%',
  ml: 'auto',
  px: [1, 2],
  color: 'white',
  bg: 'wagRed',
  fontFamily: 'body',
  fontSize: [6, 6, 7, 7]
};
var _default = FormFieldErrorMessage;
exports.default = _default;